import React from "react";
import { arrowUpDown } from "../../lib/icons";

export default function TableHeaderWithIconContainer({ label }) {
  return (
    <div className="all-tab-column-header-container">
      {" "}
      <div className="all-tab-column-header-label">{label}</div>
      <div className="all-tab-column-header-icon">{arrowUpDown}</div>
    </div>
  );
}
